/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".transaction-processing[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-direction:column;align-items:center;width:100vw;height:100vh}.transaction-processing__text[_ngcontent-%COMP%]{font-family:b-montserrat,sans-serif;font-size:1rem;text-transform:uppercase}@media screen and (min-width:1280px){.transaction-processing__text[_ngcontent-%COMP%]{font-size:1.6rem}}.transaction-processing__loader[_ngcontent-%COMP%]{font-size:1.5rem}@media screen and (min-width:1280px){.transaction-processing__loader[_ngcontent-%COMP%]{font-size:2rem}}"];
export { styles as styles };
